export default "__VITE_ASSET__BMU6wG4f__"